module.exports = __webpack_public_path__ + "img/premios-accion-voluntaria.d988ae6b.jpg";